import { type AnyApiGridQueryStateValue } from "@package/ui-redux";
import { type WritableDraft } from "immer";
import { createContext, useContext } from "react";

export type ItemGridFilterState<
  F = AnyApiGridQueryStateValue["variables"]["filter"],
> = {
  filter?: F;
  updateFilterState: (callback: (draft: WritableDraft<F>) => void) => void;
};

export const defaultItemGridFilterContextState: ItemGridFilterState = {
  filter: {},
  updateFilterState: () => {},
};

export const ItemGridFilterContext = createContext<ItemGridFilterState>(
  defaultItemGridFilterContextState,
);
export function useItemGridFilterContext<
  F = AnyApiGridQueryStateValue["variables"]["filter"],
>() {
  const context = useContext(ItemGridFilterContext);
  if (!context) {
    throw new Error(
      "useItemGridFilterContext must be used within an ItemGridFilterProvider",
    );
  }
  return context as unknown as ItemGridFilterState<F>;
}
